import { contextualize } from '@polleverywhere/cutlass'
import AnalyticsTracker from '../analytics_tracker'
import { trackingAllowed, whenAllowedToTrack } from '../analytics_tracker/util'
import { setupCannon } from './setupCannon'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import listenToSelector from '../../util/listen_to_selector'
import _ from 'underscore'

function contextualizedPrefix (role) {
  switch (role) {
    case 'embed':
    case 'participant':
      // To maintain compatibility with prior mobile/pollev.com events, don't prefix
      return ''
    default:
      return 'singularity'
  }
}

/**
 * Sent events to Cutlass
 */
export default (app) => {
  const trackingOnHold = !trackingAllowed(app)
  const cannon = setupCannon(app, trackingOnHold)

  if (!cannon) { return }

  const tracker = AnalyticsTracker(app)

  const defaultProperties = () =>
    _.pick(tracker.toJSON(), [
      'isNative',
      'platform',
      'role',
      'screen',
      'mode',
      'activePresenter',
      'iframed',
      'iframeUrl',
      'os',
      'userId',
      'participantId'
    ])

  const trackEvent = (name, properties = {}) =>
    cannon.addEvent(`singularity:${name}`,
      { ...defaultProperties(), ...properties })

  tracker.on('change:userId', (_, userId) => {
    cannon.userId = userId
  })

  tracker.on('action', trackEvent)
  tracker.on('event', trackEvent)

  if (trackingOnHold) {
    whenAllowedToTrack(app, tracker).then(() => cannon.allowTracking())
  }

  const { role } = store.getState()[appSlice.name]
  contextualize(app, contextualizedPrefix(role), (event) => {
    Object.assign(event.detail, defaultProperties())
  })

  cannon.trackCustomDomEvents()

  // track screen when app is ready which means the session has started
  listenToSelector((state) => state[appSlice.name].ready, (ready) => {
    if (ready) {
      // track if there's already a screen set
      if (tracker.has('screen')) {
        trackEvent('$view')
      }

      // listen to future screen changes
      tracker.on('change:screen', () => trackEvent('$view'))

      if (window.performance?.measure) {
        // User Timing Level 2 returns undefined, Level 3 just returns the event from measure
        let event = window.performance.measure('app-ready')
        event ||= performance.getEntriesByName('app-ready')?.[0]
        if (event) {
          trackEvent('ready', { duration: Math.floor(event?.duration || 0) })
        }
      }
    }
  })

  return cannon
}
